import { Chip } from "@mui/material";

interface Props {
    status: boolean
}

const StatusConfirmShip = ({ status }: Props) => {
    return <Chip
        style={{
            backgroundColor: status ? '#36B37E29' : '#FF563029',
            color: status ? '#1B806A' : '#B71D18',
            borderRadius: '5px'
        }}
        label={status ? "Confirm" : "Not Confirm"}
    />
}
export default StatusConfirmShip;